import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import * as spacing from '../../../styles/spacing';
import { IStyleProps } from './types';

const useStyles = makeStyles({
  activityStatusChart: {
    boxShadow: 'none',
    width: '100%',
    opacity: (props: IStyleProps) => (props.hasData ? '1' : '0.2'),
    '& > div': {
      paddingTop: '0px',
      width: '100%',
      '& #center-container > ul > li > div > span': {
        fontSize: `${spacing.default.xxsmall}`,
      },
      '& .MuiList-padding': {
        padding: '0px',
      },
    },
  },

  isLoading: {
    color: colors.lightGray,
  },
  tooltipContainer: {
    '& > div:first-of-type': {
      background: colors.gray,
      color: colors.white,
    },
    '& > div:last-of-type::after': {
      background: colors.gray,
    },
  },
  noData: {
    display: 'grid',
    height: '100px',
    color: colors.gray,
    alignContent: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    margin: '12%',
    '& p': {
      fontSize: '1rem',
      display: 'flex',
      justifyContent: 'center',
    },
  },
});

export default useStyles;
